import script from "./StreamingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamingPage.vue?vue&type=script&setup=true&lang=js"

import "./StreamingPage.vue?vue&type=style&index=0&id=2ab8913a&lang=scss"

const __exports__ = script;

export default __exports__